export const MINIMUM_BTC_WITHDRAW_AMOUNT = 0.0005;
